<template>
    <modal @close="$emit('close')" :minWidthPx="mobile ? '320' : '450'">
        <div class="text-main-text text-center font-medium text-sm pb-10 px-8">
            <br>
            <img class="flex w-2/5 mb-6 mx-auto h-24" src="@/assets/SVG/big-cross.svg"
                        alt="check-circle">
            <h2 class="text-2xl whitespace-pre" v-html="title"></h2>
            <p class="font-normal mt-4" v-html="content"></p>
        </div>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/modals.js';
import Modal from '@/views/modals/base-modal-white';

export default {
  name: 'TextModal',
  props: ['message'],
  components: { Modal },
  mixins: [ModalMixin],
  computed: {
    mobile() {
      return window.innerWidth < 840;
    },
    title() {
      if (this.message === 'У вас уже есть активная заявка на данный тип игры') {
        return 'Нельзя заказать вторую \n игру одной категории';
      }
      return 'Обратитесь \n в службу поддержки';
    },
    content() {
      if (this.message === 'У вас уже есть активная заявка на данный тип игры') {
        return 'Вы не можете заказать новую игру, пока не завершена предыдущая серия игр данной категории или не отправлена статистика по ней.';
      }
      return 'Произошла ошибка при заказе игры.';
    },
  },
};

</script>

<style scoped>
</style>
